import { schFormNumberStringOnly } from '@aloft/toolkit-shared';

import { z } from 'zod';

const emptyStringToUndefined = (arg: unknown) => {
  if (typeof arg === 'string' && arg === '') {
    return undefined;
  } else {
    return arg;
  }
};

export const schCostMultiplier = z.object({
  costMultiplier: z.preprocess(emptyStringToUndefined, schFormNumberStringOnly.optional()),
});

export type CostMultiplierFormInput = z.input<typeof schCostMultiplier>;
